// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1TU9V","container":"styles_container__2QrDI","title":"styles_title__2xuEK","wrapper":"styles_wrapper__2Oume","answer":"styles_answer__2x2VO"};